import React, { Component } from "react";
import "./Gallery.css";

import loader from "./loader.gif";
import { api } from "../List/List.consts.js";

export default class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentImageIndex: 0,
      images: this.props.vendors.scs
    };
  }
  componentWillMount() {
    this.setState({
      currentImageSRC: this.getImageURL(0)
    });
  }
  getImageURL = imageIndex => {
    const sc = this.state.images[imageIndex];

    fetch(`${api}_vendormedia/?shortcode=${sc}`)
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Network Request Failed");
      })
      .then(images => {
        if (images.name) {
          this.refs.galleryImage.src = `https://via.placeholder.com/300x300?text=Image ${imageIndex + 1}`;
        } else {
          this.refs.galleryImage.src = images[0].url;
        }
        this.setState({
          currentImageIndex: imageIndex
        });
      })
      .catch(err => {
        //error
        console.log(err.message);
      });
  };
  prevImage = () => {
    var { currentImageIndex } = this.state;
    var imageCount = this.state.images.length;
    var newImageIndex =
      currentImageIndex - 1 < 0 ? imageCount - 1 : currentImageIndex - 1;
    this.setState({
      currentImageSRC: this.getImageURL(newImageIndex)
    });
  };
  nextImage = () => {
    var { currentImageIndex } = this.state;
    var imageCount = this.state.images.length;
    var newImageIndex =
      currentImageIndex + 1 > imageCount - 1 ? 0 : currentImageIndex + 1;
    this.setState({
      currentImageSRC: this.getImageURL(newImageIndex)
    });
  };
  render() {
    const { currentImageIndex } = this.state;
    return (
      <div className="gallery">
        <div className="row">
          <div className="col-1">
            <span onClick={this.prevImage} hidden={currentImageIndex === 0}>
              <i className="fa fa-chevron-left" />
            </span>
          </div>
          <div className="col">
            <span className="img-indicator pull-right">
              {currentImageIndex + 1}/{this.state.images.length}
            </span>
            <img
              ref="galleryImage"
              src={loader}
              alt="vendor"
              className="profile-img"
            />
          </div>
          <div className="col-1">
            <span
              onClick={this.nextImage}
              hidden={this.state.images.length <= currentImageIndex + 1}
            >
              <i className="fa fa-chevron-right" />
            </span>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Gallery/Gallery.js